var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "heading" }, [_vm._v("Your selections")]),
    _vm._v(" "),
    _c("table", { staticClass: "product-selections" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _c(
            "tr",
            {
              staticClass:
                "product-selections__row product-selections__row--product"
            },
            [
              _c(
                "td",
                {
                  staticClass:
                    "product-selections__cell product-selections__cell--item",
                  attrs: { colspan: "5" }
                },
                [_vm._v(_vm._s(_vm.rangeProp) + " " + _vm._s(_vm.productProp))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "tr",
            {
              staticClass:
                "product-selections__row product-selections__row--finish"
            },
            [
              _c(
                "td",
                {
                  staticClass:
                    "product-selections__cell product-selections__cell--item product-selections__cell--finish"
                },
                [
                  _vm._v(
                    _vm._s(_vm.finishSelectedProp.title) +
                      _vm._s(
                        _vm.finishSelectedProp.inStock ? ", in stock" : ""
                      ) +
                      ":"
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticClass: "product-selections__cell",
                attrs: { colspan: "1" }
              }),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass:
                    "product-selections__cell product-selections__cell--pricenovat"
                },
                [_vm._v("£" + _vm._s(_vm.finishSelectedProp.price))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass:
                    "product-selections__cell product-selections__cell--priceplusvat"
                },
                [_vm._v("£" + _vm._s(_vm.finishSelectedProp.pricePlusVat))]
              ),
              _vm._v(" "),
              _c("td", {
                staticClass:
                  "product-selections__cell product-selections__cell--remove"
              })
            ]
          ),
          _vm._v(" "),
          _vm.valveSelectedProp.price
            ? _c(
                "tr",
                {
                  staticClass:
                    "product-selections__row product-selections__row--finish"
                },
                [
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--item product-selections__cell--finish"
                    },
                    [_vm._v(_vm._s(_vm.valveSelectedProp.title) + ":")]
                  ),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "product-selections__cell",
                    attrs: { colspan: "1" }
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--pricenovat"
                    },
                    [_vm._v("£" + _vm._s(_vm.valveSelectedProp.price))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--priceplusvat"
                    },
                    [_vm._v("£" + _vm._s(_vm.valveSelectedProp.pricePlusVat))]
                  ),
                  _vm._v(" "),
                  _c("td", {
                    staticClass:
                      "product-selections__cell product-selections__cell--remove"
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.supplementaryHeaterProp
            ? _c(
                "tr",
                {
                  staticClass:
                    "product-selections__row product-selections__row--finish"
                },
                [
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--item product-selections__cell--finish"
                    },
                    [_vm._v(_vm._s(_vm.supplementaryHeaterProp.title) + ":")]
                  ),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "product-selections__cell",
                    attrs: { colspan: "1" }
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--pricenovat"
                    },
                    [_vm._v("£" + _vm._s(_vm.supplementaryHeaterProp.price))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--priceplusvat"
                    },
                    [
                      _vm._v(
                        "£" + _vm._s(_vm.supplementaryHeaterProp.pricePlusVat)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", {
                    staticClass:
                      "product-selections__cell product-selections__cell--remove"
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.accessoriesSelectedProp, function(accessory) {
            return _c("AcessorySummary", {
              key: accessory.id,
              attrs: { accessory: accessory },
              on: {
                accessoryQtyChanged: _vm.accessoryQtyChanged,
                accessoryRemoved: _vm.accessoryRemoved
              }
            })
          }),
          _vm._v(" "),
          parseFloat(_vm.surchargeTotal) > 0
            ? _c(
                "tr",
                {
                  staticClass:
                    "product-selections__row product-selections__row--finish"
                },
                [
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--item product-selections__cell--finish"
                    },
                    [_vm._v("Surcharge:")]
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "product-selections__cell" }),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--pricenovat"
                    },
                    [_vm._v("£" + _vm._s(_vm.surchargeTotal))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "product-selections__cell product-selections__cell--priceplusvat"
                    },
                    [_vm._v("£" + _vm._s(_vm.surchargeTotalPlusVat))]
                  ),
                  _vm._v(" "),
                  _c("td", {
                    staticClass:
                      "product-selections__cell product-selections__cell--remove"
                  })
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("tfoot", [
        _c(
          "tr",
          {
            staticClass:
              "product-selections__row product-selections__row--footer"
          },
          [
            _c(
              "td",
              {
                staticClass:
                  "product-selections__cell product-selections__cell--total"
              },
              [_vm._v("Total:")]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "product-selections__cell" }),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass:
                  "product-selections__cell product-selections__cell--pricenovat product-selections__cell--pricenovat-total"
              },
              [_vm._v("£" + _vm._s(_vm.totalPrice))]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass:
                  "product-selections__cell product-selections__cell--priceplusvat product-selections__cell--priceplusvat-total"
              },
              [_vm._v("£" + _vm._s(_vm.totalPricePlusVat))]
            ),
            _vm._v(" "),
            _c("td", {
              staticClass:
                "product-selections__cell product-selections__cell--remove"
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        {
          staticClass:
            "product-selections__row product-selections__row--heading"
        },
        [
          _c(
            "th",
            {
              staticClass:
                "product-selections__cell product-selections__cell--heading"
            },
            [_vm._v("Item")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass:
                "product-selections__cell product-selections__cell--heading"
            },
            [_vm._v("Qty")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass:
                "product-selections__cell product-selections__cell--heading"
            },
            [_vm._v("Price")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass:
                "product-selections__cell product-selections__cell--heading"
            },
            [_vm._v("+VAT")]
          ),
          _vm._v(" "),
          _c("th", {
            staticClass:
              "product-selections__cell product-selections__cell--heading"
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }